
import { defineComponent } from 'vue'
import BannersComponent from '@/components/BannersComponent.vue'
import AsahiButton from '@/components/library/AsahiButton.vue'

export default defineComponent({
  name: 'BannerSection',
  components: {
    BannersComponent,
    AsahiButton
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    }
  },
  methods: {
    joinUs () {
      this.$navigate('/login')
    }
  }
})
